import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=7795db52&"
import script from "./Disclaimer.vue?vue&type=script&lang=ts&"
export * from "./Disclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VContainer,VContent,VDivider,VResponsive})
